export default __webpack_public_path__ + "static/media/Avatar-10.988aeac2.svg";